import { render, staticRenderFns } from "./ecology.vue?vue&type=template&id=01bf3c36&scoped=true&"
import script from "./ecology.vue?vue&type=script&lang=js&"
export * from "./ecology.vue?vue&type=script&lang=js&"
import style0 from "./ecology.vue?vue&type=style&index=0&id=01bf3c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf3c36",
  null
  
)

export default component.exports